import 'reflect-metadata';
import { Vue, Component, Prop, Model, Watch } from 'vue-property-decorator';
import { State, Action, Getter, Mutation } from 'vuex-class';

import { User, MenuItem } from '../../assets/interfaces/interfaces';

interface NavBarField {
  label: string;
  type: string;
  onClick: () => void;
}

@Component({
  name: 'TheNavBar',
})
export default class TheNavBar extends Vue {
    // DATA
    @Prop({ default: 1264, required: false })
    private readonly navigationBreakpoint = 1264;

    @Prop({ default: 300, required: false })
    private readonly browserWidth: number;

    @Prop({ default: 300, required: false })
    private readonly mobileWidth: number;

    private drawer: boolean = true;

    private notification: string = 'mdi-bell';

    private screenSize = {
      width: window.innerWidth,
      height: window.innerHeight,
    };

    @Getter('projectName') private projectName: string;

    @Getter('viewName') private viewName: string;

    @Getter('user') private user: User;

    @Getter('views') private views: any[];

    @Getter('options') private options: string[];

    // COMPUTED
    private get menuItems(): MenuItem[] {
      const items = this.views.filter((item: any) => {
        const show = item.showInMenu !== false;
        return show;
      });

      return items;
    }

    // METHODS
    private toggleNotification() {
      if (this.notification === 'mdi-bell') {
        this.notification = 'mdi-bell-off';
      } else {
         this.notification = 'mdi-bell';
      }
    }

    @Watch('drawer')
    private setCloseOverlayAction(drawer: boolean) {
      setTimeout(() => {
        (document.querySelector('.v-overlay__scrim') as HTMLElement).onclick = () => this.drawer = !this.drawer;
      })
    }

    private handleResize() {
      this.screenSize.width = window.innerWidth;
      this.screenSize.height = window.innerHeight;
    }

    created() {
      window.addEventListener('resize', this.handleResize);
    }
}
